import Vue, { getCurrentInstance } from "vue";
import Vuetify from "vuetify";
// @ts-ignore
import ru from "vuetify/es5/locale/ru";
import "@rmp/core/plugins/vuetify/style.scss";
import "@rmp/core/scss/overrides.scss";
import "@mdi/font/css/materialdesignicons.css";
import i18n from "@rmp/core/plugins/i18n/core";

Vue.use(Vuetify);

export const useVuetify = () => {
	const instance = getCurrentInstance();
	if(!instance) {
		throw new Error(i18n.t("errors.useVuetifyOutsideSetup").toString());
	}
	return instance.proxy.$vuetify;
};

export default new Vuetify({
	theme: {
		options: {
			customProperties: true
		},
		themes: {
			light: {
				primary: {
					base: "#00B7C5",
					lighten1: "#33C5D1",
					lighten2: "#66D4DC",
					lighten3: "#99E2E8",
					lighten4: "#CCF1F3",
					lighten5: "#E6F8F9",
					darken1: "#00C8D8",
					darken2: "#00A9C2",
					darken3: "#063E78"
				},
				secondary: {
					base: "#003D7C",
					lighten1: "#336496",
					lighten2: "#668BB0",
					lighten3: "#99B1CB",
					lighten4: "#CCD8E5",
					darken1: "#003265",
					darken2: "#003163"
				},
				grey: {
					base: "#f5f5f5",
					lighten1: "#A4A4A5",
					lighten2: "#F7F9FC",
					lighten3: "#CBD2DD",
					lighten4: "#F4F4F4",
					darken1: "#8D8D8F",
					darken2: "#555556",
					darken4: "#1A1A1F"
				},
				neutral: {
					lighten3: "#D1D1D2",
					darken3: "#383839"
				},
				purple: {
					base: "#6750A3"
				},
				accent: "#A989EE",
				error: {
					base: "#B60505",
					lighten1: "#C43232",
					darken1: "#920404"
				},
				success: "#14884E",
				warning: "#FF8B41",
				white: {
					base: "#FFFFFF",
					lighten1: "#F5F5F5",
					lighten2: "#F6F7F9",
					lighten3: "#e9e9e9",
					lighten4: "#F1F1F1",
					darken1: "#e9ecef",
					darken4: "#717172"
				},
				orange: {
					base: "#FFA800"
				},
				red: {
					base: "#FF4040",
					lighten4: "#FFE7E7",
					lighten5: "#FFF2F2"
				},
				blue: {
					base: "#3B82F6",
					lighten3: "#DBEAFE"
				},
				green: {
					lighten3: "#ECF7F1",
				}
			}
		}
	},
	lang: {
		locales: { ru },
		current: "ru"
	}
});
